export default __webpack_public_path__ + "static/media/warning.4ac4916c.jpg";